// extracted by mini-css-extract-plugin
module.exports = {"switch-container":"styles_switch-container__2fyjf","switch":"styles_switch__1oxwT","slider":"styles_slider__2RLRt"};